import { FC } from "react";
import { AddButton } from "src/components/ui-icons/buttons";
import TGButton from "src/components/ui/TGButton";

interface IProps {
  openTest: () => void;
}

export const AddTest: FC<IProps> = ({ openTest }) => {
  return (
    <div className="mb-[10px]">
      <TGButton icon={<AddButton />} className="w-full text-[#637381]" onClick={openTest}>
        Добавить тест
      </TGButton>
    </div>
  );
};
